import React from 'react';

export const CenteredText = ({ children }) => (
  <div className='flex justify-center mt-12'>
    <p>
      {children}
    </p>
  </div>
);
